module.exports = __webpack_public_path__ + "img/ZB52_08.d0fb5b7d.jpg";